import { Base } from "ui/Scripts/source/framework/base";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";

export interface IUserGroupPageAuthorizationLevels {
    authorizationLevels: INumberTitle[];
}

export class UserGroupPageAuthorizationLevels implements IUserGroupPageAuthorizationLevels {
    authorizationLevels: NumberTitle[];

    constructor();
    constructor(obj: IUserGroupPageAuthorizationLevels);
    constructor(obj?: any) {
        this.authorizationLevels = Base.getTypedArray(obj ? obj.authorizationLevels : null, NumberTitle);
    }
}